import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Builds.css';

const builds = [
  {
    name: 'vacuum',
    path: '/builds/vacuum',
    date: '2026-03-01',
    models: ['Sonnet 3.6', 'Opus 3.6'],
    platform: 'Claude Code',
    age: 6,
  },
];

function Builds() {
  return (
    <div className="builds">
      <Helmet>
        <title>Builds - Lowell Handy</title>
        <meta property="og:title" content="Builds" />
        <meta property="og:description" content="Builds by Lowell Handy" />
      </Helmet>
      <h1>builds</h1>
      <table>
        <thead>
          <tr>
            <th>date</th>
            <th>age</th>
            <th>project</th>
            <th>platform</th>
            <th>models</th>
          </tr>
        </thead>
        <tbody>
          {builds.map((b) => (
            <tr key={b.name}>
              <td>{b.date}</td>
              <td>{b.age}</td>
              <td><Link to={b.path}>{b.name}</Link></td>
              <td>{b.platform}</td>
              <td>{b.models.map((m) => <code key={m}>{m}</code>)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Builds;
